import React, { useEffect, useState } from "react";
import useHttp from '../../../../hook/use-http';
import { Chart } from 'react-google-charts';
import NoData from "../NoData";
import ChartLoader from "../ChartLoader";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates";
import WaterMark from "../../DashboardMain/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import BuketsTableROCVehicle from "../BuketsTableROCVehicle";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata

export default function ROC_vehicle({ apiend, gloablfilter, type }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [filteredData, SetfilteredData] = useState([]);
  const [toggleFleetBar, setToggleFleetBar] = useState(false);
  let barColor_new = "#348393"

  let toPush = [];
  const appyData = (data) => {
    (type === 'Slow') ? barColor_new = "#348393" : barColor_new = "#FFA650"
    const res_result = data;

    let responce = {
      "<=2.5": { per: 0, count: 0 },
      "5": { per: 0, count: 0 },
      "7.5": { per: 0, count: 0 },
      "10": { per: 0, count: 0 },
      "12.5": { per: 0, count: 0 },
      "15": { per: 0, count: 0 },
      "17.5": { per: 0, count: 0 },
      "20": { per: 0, count: 0 },
      ">20": { per: 0, count: 0 }
    };
    if (res_result.length === 0) {
      setChartData((prestate) => []);
    }
    if (res_result.length != 0) {
      let t_val = res_result[0];
      if (t_val.doc_count != 0) {
        if (t_val["ROC_less_2.5"].value > 0) {
          responce["<=2.5"] = { per: parseInt(t_val["ROC_less_2.5"].value * 100), sum: parseInt(t_val["ROC_less_2.5"].value) };
        }
        if (t_val["ROC_less_5"].value > 0) {
          responce["5"] = { per: parseInt(t_val["ROC_less_5"].value * 100), sum: parseInt(t_val["ROC_less_5"].value) };
        }
        if (t_val["ROC_less_7.5"].value > 0) {
          responce["7.5"] = { per: parseInt(t_val["ROC_less_7.5"].value * 100), sum: parseInt(t_val["ROC_less_7.5"].value) };
        }
        if (t_val["ROC_less_10"].value > 0) {
          responce["10"] = { per: parseInt(t_val["ROC_less_10"].value * 100), sum: parseInt(t_val["ROC_less_10"].value) };
        }
        if (t_val["ROC_less_12.5"].value > 0) {
          responce["12.5"] = { per: parseInt(t_val["ROC_less_12.5"].value * 100), sum: parseInt(t_val["ROC_less_12.5"].value) };
        }
        if (t_val["ROC_less_15"].value > 0) {
          responce["15"] = { per: parseInt(t_val["ROC_less_15"].value * 100), sum: parseInt(t_val["ROC_less_15"].value) };
        }
        if (t_val["ROC_less_17.5"].value > 0) {
          responce["17.5"] = { per: parseInt(t_val["ROC_less_17.5"].value * 100), sum: parseInt(t_val["ROC_less_17.5"].value) };
        }
        if (t_val["ROC_less_20"].value > 0) {
          responce["20"] = { per: parseInt(t_val["ROC_less_20"].value * 100), sum: parseInt(t_val["ROC_less_20"].value) };
        }
        if (t_val["greater_20"].value > 0) {
          responce[">20"] = { per: parseInt(t_val["greater_20"].value * 100), sum: parseInt(t_val["greater_20"].value) };
        }
        toPush.push(t_val["ROC_less_2.5"].value)
        toPush.push(t_val["ROC_less_5"].value)
        toPush.push(t_val["ROC_less_7.5"].value)
        toPush.push(t_val["ROC_less_10"].value)
        toPush.push(t_val["ROC_less_12.5"].value)
        toPush.push(t_val["ROC_less_15"].value)
        toPush.push(t_val["ROC_less_17.5"].value)
        toPush.push(t_val["ROC_less_20"].value)
        toPush.push(t_val["greater_20"].value)
        SetfilteredData(toPush)

        let res_result_final = [["Element", "Count", { role: "style" }]]
        let loop_keys = Object.keys(responce);
        loop_keys = ["<=2.5", "5", "7.5", "10", "12.5", "15", "17.5", "20", ">20"]
        let responce1 = []
        loop_keys.map(x => {
          if (x != "doc_count") {
            // res_result_final.push([x, responce[x].sum, barColor_new]);
            res_result_final.push([x, responce[x].sum, `{stroke-width: 1;stroke-color: black;color:${barColor_new}}`]);
            responce1.push(responce[x].sum)
          }
        })
        const labels = ["<2.5", "5", "7.5", "10", "12.5", "15", "17.5", "20", ">=20"]

        Maxchartdata = {
          labels,
          datasets: [
            {
              label: "Max Battery temp (oC)",
              data: responce1,
              backgroundColor: barColor_new,
              borderWidth: 1,
              borderColor: "black",
            },
          ]
        }
        setChartData((prestate) => res_result_final);
      } else {
        setChartData((prestate) => []);
      }
    }
  }

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Rate of Charge (%/hr)'
        },
        suggestedMin: 0,
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Charging Cycles'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: {
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
      ,
      gridlines: {
        color: 'transparent'
      },
      title: 'Rate of Charge (%/hr)',
      minValue: 0,
      format: 'short',
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Charging Cycles',
      minValue: 0,
      format: '#\'',
    },
    bar: { groupWidth: "100%" },
    tooltip: { isHtml: true },
    legend: "none",
  };

  const [barColor, setBarColor] = useState("#348393")
  useEffect(() => {
    (type === 'Slow') ? setBarColor("#348393") : setBarColor("#FFA650")
    if (toggleFleetBar === false) {
      fetchData({ url: API_URL_MAIN + "chargingpage_api/" + apiend, body: { filterdata: gloablfilter, type: type } }, appyData)
    } else {
      fetchData({ url: API_URL_MAIN + "chargingpage_api/" + apiend, body: { filterdata: gloablfilter, type: type } }, appyData)
    }
  }, [gloablfilter, type])

  const appyDataClick = (data) => {
    let hits = data;
    hits.map((i, key) => {
      toPush.push(i.fields.ROC[0])
    })
    SetfilteredData(toPush.sort())
  }

  const chartEvents = [
    {
      eventName: "select",
      callback({ chartWrapper }) {
        const chart = chartWrapper.getChart()
        const selection = chart.getSelection()
        const [selectedItem] = selection;
        const { row } = selectedItem;
        const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
        let from_bucket;
        let to_bucket;
        if (barvalue === "<=2.5") {
          from_bucket = 0
          to_bucket = 2.5
        } else if (barvalue === ">20") {
          from_bucket = 20
          to_bucket = null
        } else {
          from_bucket = barvalue - 2.5
          to_bucket = barvalue
        }
        fetchData({ url: API_URL_MAIN + "chargingpage_api/ROC_vehicle_click", body: { filterdata: gloablfilter, type: type, from_bucket: from_bucket, to_bucket: to_bucket } }, appyDataClick)
        window.$('#exampleModal__' + apiend).modal('show');
      }
    }
  ];

  const handleChangeDuration = (e) => {
    setToggleFleetBar(e.target.checked)
    if (e.target.checked === false) {
      fetchData({ url: API_URL_MAIN + "chargingpage_api/" + apiend, body: { filterdata: gloablfilter, type: 'Slow' } }, appyData)
    } else {
      fetchData({ url: API_URL_MAIN + "chargingpage_api/" + apiend, body: { filterdata: gloablfilter, type: 'Fast' } }, appyData)
    }
  }

  return (
    <>
      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>
      <WaterMark />
      {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={chartEvents} />)}
      {/* model for zoom */}
      <div className="modal fade" id={apiend + "_modal"} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">Rate of charging {type} chrg</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: "400px" }}>
              {
                (isLoading) ? <ChartLoader /> : ((chartdata.length === 0) ? <NoData /> :
                  <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                )}
            </div>
          </div>
        </div>
      </div>
      {/* model for zoom */}

      {/* model for table */}
      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Rate of charging {type} chrg</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                  <tr>
                    <th scope="col">value</th>
                  </tr></thead>
                <tbody>
                  <BuketsTableROCVehicle data={filteredData} />
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
      {/* model for table */}
    </>
  );
}
